/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Lv2SelectOptionBtn from "./Lv2SelectOptionBtn";
import LengthWeightDisableBtn from "./LengthWeightDisableBtn";
import Lv2SelectOptionBtnGrey from "./Lv2SelectOptionBtnGrey";
import SubOptionsLv2ExtraDescription from "./SubOptionsLv2ExtraDescription";
import { connect } from "react-redux";
import product from "../../../../models/product";
// CSS
import "../../../../css/WeightSection.css";
import getArrWithAvaliable from "../../../../function/getArrWithAvaliable";

let $ = window.$;

class SubOptionLv2Section extends React.Component {
  componentDidMount() {
    const {
      changeLv2SelectOptionDefault,
      selectLv2Option,
      ui,
      activeOptionIndex
    } = this.props;
    const lv2OptionDefault = ui.options[activeOptionIndex].option.defaultShow;
    const defaultCode = lv2OptionDefault.lv2Code;

    if (lv2OptionDefault === undefined) return;
    //更新Lv3List
    selectLv2Option(defaultCode);
    changeLv2SelectOptionDefault(defaultCode);
  }
  componentDidUpdate() {
    const {
      isClick,
      subOptionLv2List,
      changeLv2SelectOptionDefault,
      ui,
      activeOptionIndex
    } = this.props;
    const lv2OptionDefault = ui.options[activeOptionIndex].option.defaultShow;

    let lv2Default;

    if (isClick) {
      //傳第一筆資料
      lv2Default =
        (subOptionLv2List.hasOwnProperty("subitems") &&
          subOptionLv2List.subitems[0].code) ||
        "";
    } else {
      //傳預設值
      lv2Default = (lv2OptionDefault && lv2OptionDefault.lv2Code) || "";
    }
    changeLv2SelectOptionDefault(lv2Default);
  }

  handleScrollBug = () => {
    // 調整sizeGuide捲動事件的bug
    $(".modal-backdrop").css("z-index", "-1");
    $("#modal_sizeGuide").css("background", "rgba(0,0,0,0.5)");
  };

  render() {
    /* 
    subOptionLv2DisplayList : 顯示的長度
    subOptionLv2List: 有效的長度
    以下的函數用來顯示有效的選項為白色，無效的選項為灰色。
    */
    const { subOptionLv2List, subOptionLv2DisplayList, ui, activeOptionIndex } =
      this.props;
    const title = subOptionLv2DisplayList.title;
    let component;
    const hasLv2 =
      ui.options[activeOptionIndex].option.display.hasOwnProperty("lv2");
    let sizeGuideMessage = "";
    if (hasLv2) {
      sizeGuideMessage =
        ui.options[activeOptionIndex].option.display.lv2.sizeGuideMessage;
    }
    const subitemslength =
      (subOptionLv2List.subitems && subOptionLv2List.subitems.length) || 0;

    if (
      subOptionLv2List.hasOwnProperty("subitems") &&
      subOptionLv2DisplayList.hasOwnProperty("subitems")
    ) {
      const arrayWithAvaliable = getArrWithAvaliable(
        subOptionLv2DisplayList.subitems, //display list
        subOptionLv2List.subitems //relations list
      );
      component = arrayWithAvaliable.map((item, index) => {
        if (item.status === "available") {
          return (
            <Lv2SelectOptionBtn
              cbu={item.cbu}
              cci={item.cci}
              key={index}
              index={index}
              name={item.name}
              code={item.code}
              type="lv2"
              className="option-btn"
            />
          );
        } else if (item.status === "outOfStock") {
          return (
            <Lv2SelectOptionBtnGrey
              key={index}
              index={index}
              name={item.name}
              code={item.code}
              type="lv2"
              className="option-btn"
            />
          );
        }
        return (
          //沒有這個選項不出現
          <LengthWeightDisableBtn
            className="option-btn"
            key={index}
            name={item.name}
          />
        );
      });
    }

    return subitemslength >= 1 && subOptionLv2DisplayList.subitems ? (
      <div className="detailsSection ringMeasure_wrap small-txt-link-wrap">
        <p className="subtitle">
          <span style={{ textTransform: "capitalize" }}>{title}</span>
        </p>
        <div id="lv2Section" className="optionBoxes">
          {component}
          <SubOptionsLv2ExtraDescription />
          {(sizeGuideMessage && sizeGuideMessage !== null && (
            <a
              className="ringMeasureGuide blockBtn border-grey smaller"
              data-toggle="modal"
              data-target="#modal_sizeGuide"
              onClick={this.handleScrollBug}
            >
              <span>
                <span className="icon-ruler" />
                <br />
                <span className="text">{sizeGuideMessage}</span>
              </span>
            </a>
          )) ||
            null}
        </div>
        {/* {(resizing && customeriza && (
          <div className="measureNotFound_wrap">
            <a href="/" className="content-link">
              無法找到你的尺寸
            </a>
          </div>
        )) ||
          null} */}
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = state => {
  return {
    subOptionLv2DisplayList: state.product.subOptionLv2DisplayList,
    subOptionLv2List: state.product.subOptionLv2List,
    isClick: state.product.isLv1Click,
    resizing: state.product.product.resizing,
    customeriza: state.product.product.customeriza,
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex
  };
};
const mapDispatchToProps = () => {
  return {
    selectLv2Option: index => product.actions.selectLv2Option(index),
    changeLv2SelectOptionDefault: data =>
      product.actions.changeLv2SelectOptionDefault(data)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubOptionLv2Section);
